export default "__VITE_ASSET__300de18d__"